
import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class Choice extends Vue {
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  public serverData;
  public obj = {};
  public created() {
    const obj: any = this.$route.query.obj;
    this.obj = JSON.parse(obj);
  }
}
